export function phoneValidation(value: string): {invalidPhone?: boolean} {

    let regex = /^[0+]{1,2}([-\s]*\d){9,12}$/;

    if (!regex.test(value)) {
        return { invalidPhone: true };
    }

    return {};
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./~/@teamui/validation/validation/phone.ts
 **/